import React from "react";
import MainImage from "../../assets/MainImage1.jpg";
import Footer from "../../components/Footer";
import PastWork from "../../components/PastWord";
import NavLite from "../../components/NavLite";

function Services() {
  return (
    <main className="relative min-h-screen w-screen overflow-x-hidden bg-[#F4F3E1 ]">
      <title>Web Design & SEO Services for Women-Led Businesses | Her Growth Co.</title>
      <meta
        name="description"
        content="Explore our full suite of services—from custom web design to SEO campaigns—built to elevate women-owned businesses and drive real visibility."
      />
      <meta
        name="keywords"
        content="full-service design and SEO for women, expert branding and strategy, premium web solutions for female founders, creative agency for women leaders, visibility and conversion packages, growth-focused design offers, women-first web agency, business website solutions for women in business, Austin SEO & web packages, high-end website design texas, premium web design services, austin custom website development, conversion-focused web design, mobile responsive web design austin, website design for coaches, ux/ui website design austin, brand-first website design, premium branding website texas, website design for consultants, creative web design agency austin, bespoke web development texas, web design for personal brands austin, austin expert wordpress designer, strategic website design for leads, lead generation web design austin, custom web graphics austin, lightning-fast websites austin tx, mobile-first web design texas, expert website builder for women entrepreneurs, website design for experts texas, web designer for thought leaders, seo-ready website builds, visually engaging websites texas, ux design for female-led businesses"
      />

      <section className="bg-[#F7F3F2]">
        <div
          className="relative h-auto bg-cover bg-center object-top"
          style={{
            clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
            backgroundImage: `url(${MainImage})`,
            padding: "20px",
            width: "100%",
          }}
        >
          <NavLite />
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex items-center justify-center">
              <h1 className="text-black italic text-3xl max-w-96 font-semibold bg-[#CFF098]">All Services</h1>
            </div>
          </div>
        </div>

        <section className="bg-[#F7F3F2]">
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex flex-col items-center text-center">
              <h2 className="text-3xl font-regular md:text-5xl text-black max-w-2xl uppercase">
                Unlock Your Online Potential
              </h2>
              <p className="mb-8 mt-4 max-w-lg text-base text-black md:mb-12 md:text-lg font-light">
                We provide tailored web design and SEO services to help women-run businesses thrive online.
              </p>
            </div>

            {/* Core Web Design Packages Section */}
            <div className="mb-12">
              <h2 className="text-2xl font-semibold text-black text-center mb-8">
                3 Popular Packages
              </h2>
              <div className="grid gap-5 sm:grid-cols-1 md:grid-cols-3 md:gap-4">
                {/* Package 1: Authority Launchpad */}
                <div className="grid gap-6 border border-solid border-black p-8 md:p-10 bg-white rounded-xl">
                  <h3 className="text-xl font-semibold text-black text-center">The Authority Launchpad</h3>
                  <p className="text-black text-lg font-light text-center">
                    Build a strong foundation and elevate your brand presence.
                  </p>
                  <ul className="text-black text-base font-light list-disc list-inside mt-4">
                    <li>5-Page Elite Website Design</li>
                    <li>Foundational SEO Setup</li>
                    <li>Mobile-Responsive Design</li>
                    <li>Content Integration Guidance</li>
                    <li>Professional Stock Imagery</li>
                    <li>Basic Analytics Setup</li>
                  </ul>
                </div>

                {/* Package 2: Strategic Growth Accelerator */}
                <div className="grid gap-6 border border-solid border-black p-8 md:p-10 bg-white rounded-xl">
                  <h3 className="text-xl font-semibold text-black text-center">The Strategic Growth Accelerator</h3>
                  <p className="text-black text-lg font-light text-center">
                    Drive traffic, generate leads, and grow your authority.
                  </p>
                  <ul className="text-black text-base font-light list-disc list-inside mt-4">
                    <li>Conversion-Optimized Website (Up to 7 Pages)</li>
                    <li>Targeted Local SEO Strategy</li>
                    <li>Lead Capture & Email Integration</li>
                    <li>Portfolio/Case Study Section</li>
                    <li>Performance Tracking & Insights Report</li>
                  </ul>
                </div>

                {/* Package 3: Authority Amplifier */}
                <div className="grid gap-6 border border-solid border-black p-8 md:p-10 bg-white rounded-xl">
                  <h3 className="text-xl font-semibold text-black text-center">The Authority Amplifier</h3>
                  <p className="text-black text-lg font-light text-center">
                    Maximize visibility and dominate your niche.
                  </p>
                  <ul className="text-black text-base font-light list-disc list-inside mt-4">
                    <li>Bespoke 12-Page Website Design</li>
                    <li>Advanced SEO Strategy</li>
                    <li>Conversion Rate Optimization</li>
                    <li>Content Strategy + 2 Blog Posts</li>
                    <li>Social Media Optimization</li>
                    <li>Dedicated Project Manager & Support</li>
                    <li>Post-Launch Training & Support</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center mt-10 mb-10">
              <a href="/webdesign" className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black">
                View Web Design Packages →
              </a>
              <p className="text-black text-lg font-light mt-6 w-[400px] text-center">
                Unlock the power of a professionally designed website.
              </p>
            </div>

            {/* SEO Services Section */}
            <div className="mb-12">
              <h2 className="text-2xl font-semibold text-black text-center mb-8">
                Our SEO Services
              </h2>
              <div className="grid gap-5 sm:grid-cols-1 md:grid-cols-2 md:gap-4">
                {/* Visibility Audit */}
                <div className="grid gap-6 border border-solid border-black p-8 md:p-10 bg-white rounded-xl">
                  <h3 className="text-xl font-semibold text-black">Visibility Audit</h3>
                  <p className="text-black text-lg font-light">
                    Discover what’s holding back your site’s performance and how to fix it.
                  </p>
                  <ul className="text-black text-base font-light list-disc list-inside mt-4">
                    <li>Website & Mobile Analysis</li>
                    <li>On-Page SEO Review</li>
                    <li>Local SEO Checkup</li>
                    <li>Custom SEO Action Plan</li>
                  </ul>
                </div>

                {/* Local SEO Accelerator */}
                <div className="grid gap-6 border border-solid border-black p-8 md:p-10 bg-white rounded-xl">
                  <h3 className="text-xl font-semibold text-black">Local SEO Accelerator</h3>
                  <p className="text-black text-lg font-light">
                    Improve your online visibility with local SEO strategies designed to boost your rankings.
                  </p>
                  <ul className="text-black text-base font-light list-disc list-inside mt-4">
                    <li>Google Business Profile Optimization</li>
                    <li>Local Keyword Research</li>
                    <li>Service Page SEO Optimization</li>
                    <li>Reviews & Performance Reporting</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center mt-10">
              <a href="/seopage" className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black">
                View SEO Packages →
              </a>
              <p className="text-black text-lg font-light mt-6 w-[400px] text-center">
                Let's turn your online presence into a sales machine.
              </p>
            </div>
          </div>
          <PastWork />
        </section>
        <Footer />
      </section>
    </main>
  );
}

export default Services;
